<template>
  <div class="form-section mt-32">
    <h3 class="section-title">희망 활동처</h3>
    <ul class="check-list">
      <li>
        <div class="activity-item">
          <span class="th-name">1순위</span>
          <div class="input-area">
            <input
              type="text"
              :placeholder="placeholder"
              :title="title + ' 1순위 입력'"
              :value="wishComp1"
              :disabled="isDisabled"
            >
          </div>
        </div>
        <div class="activity-item">
          <span class="th-name">2순위</span>
          <div class="input-area">
            <input
              type="text"
              :placeholder="placeholder"
              :title="title + ' 2순위 입력'"
              :value="wishComp2"
              :disabled="isDisabled"
            >
          </div>
        </div>
        <div class="activity-item">
          <span class="th-name">3순위</span>
          <div class="input-area">
            <input
              type="text"
              :placeholder="placeholder"
              :title="title + ' 3순위 입력'"
              :value="wishComp3"
              :disabled="isDisabled"
            >
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'WishCompanySection',
  props: {
    wishComp1: {
      type: String,
      default: ''
    },
    wishComp2: {
      type: String,
      default: ''
    },
    wishComp3: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '입력해 주세요.'
    },
    title: {
      type: String,
      default: '희망 활동처'
    },
  },
};
</script>



// WEBPACK FOOTER //
// WishCompanySection.vue?3f289c70